import { ContentLoader, List } from "../../components";
import React, { useEffect, useState } from "react";
import { DeviceApi } from "../../apis";
import { useApi } from "../../hooks";
import Other from "./other";
import { Flex } from "antd";
import Item from "./item";

const AlarmListLayout = ({
  value = {},
  filter = {},
  renderFooter = () => null,
}) => {
  const [loading, setLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [device, setDevice] = useState(value);
  const { execute } = useApi();

  useEffect(() => {
    getDevices();
  }, []);

  const getDevices = async () => {
    const devices = await execute(() => DeviceApi.types(filter), {
      setLoading,
    });
    setDevices(devices);
  };

  if (loading)
    return (
      <ContentLoader
        gap="3rem"
        skeletons={[{ height: "43.2rem" }, { height: "21.6rem" }]}
      />
    );
  return (
    <React.Fragment>
      <Flex
        vertical
        gap={"3rem"}
        children={React.Children.toArray(
          devices.map((items) => (
            <List
              className="list"
              dataSource={items}
              highlightOnHover={false}
              renderItem={(item) => (
                <Item
                  {...item}
                  onClick={() => setDevice(item)}
                  active={device?.uuid === item.uuid}
                />
              )}
            />
          ))
        )}
      />
      {renderFooter(device)}
    </React.Fragment>
  );
};

AlarmListLayout.Other = Other;
export default AlarmListLayout;
